import { createFileRoute } from '@tanstack/react-router';
import { RetirementWithholdingSlipProfileRegistryPage } from './-components/RetirementWithholdingSlipProfileRegistryPage';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/settings/retirement-withholding-slips/')({
  component: RetirementWithholdingSlipProfileRegistryPage
});